module.exports = __webpack_public_path__ + "img/singapore-fw.34565dd.png";